var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.846,
    height: 12.846,
    viewBox: "0 0 12.846 12.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".export{fill:#fff;stroke:#fff;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "export",
    d: "M240.392,8.887A.392.392,0,0,1,240,8.495V.392a.392.392,0,1,1,.784,0v8.1A.392.392,0,0,1,240.392,8.887Zm0,0",
    transform: "translate(-234.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "export",
    d: "M157.155,248.192a.389.389,0,0,1-.277-.115l-2.091-2.091a.392.392,0,0,1,.555-.555l1.814,1.814,1.814-1.814a.392.392,0,0,1,.555.555l-2.091,2.091a.393.393,0,0,1-.278.115Zm0,0",
    transform: "translate(-150.882 -239.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "export",
    d: "M11.108,345.514H1.438A1.439,1.439,0,0,1,0,344.076v-2.352a.392.392,0,0,1,.784,0v2.352a.654.654,0,0,0,.653.653h9.671a.654.654,0,0,0,.653-.653v-2.352a.392.392,0,0,1,.784,0v2.352A1.439,1.439,0,0,1,11.108,345.514Zm0,0",
    transform: "translate(0 -332.968)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.7bc9da805578a90553b3686f56c1098e.svg";
export { ForwardRef as ReactComponent };